import styled from 'styled-components';
import { PageHeader } from 'antd';

export const PageHeaderStyled = styled(PageHeader)`
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;

  .ant-page-header-heading-left {
    align-items: start;
    flex-direction: column;
  }
`;
